import { Box } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_LANDING_PAGE } from "../../Routes/RouteMapping";
import { INSTA_EDU_CONTENT } from "../../utils/constants";
import { launchSDK } from "../../utils/helpers";
import {
  InvertedPrimaryButton,
  PrimaryButton,
  FullScreenLoader,
  AttentionBox,
} from "../index";
import "./GenericMessage.scss";
function InstagramGenericMessage({SetLoader}) {
  
  const navigate = useNavigate();
  return (
    <div className="message-container">
      <Box >
        <p className="header">{INSTA_EDU_CONTENT.header}</p>
        <p className="insta-message-point">{INSTA_EDU_CONTENT.message}</p>
        <video
          className="video-container"
          controls
          controlsList="nodownload"
          preload="metadata"
        >
          <source
            src={INSTA_EDU_CONTENT.videoUrl}
            type="video/mp4"
          />
        </video>
      </Box>
      <AttentionBox content={INSTA_EDU_CONTENT.attentionBoxContent} />
      <div className="button-group">
        <PrimaryButton
          onClick={() => launchSDK(SetLoader, navigate)}
          htmlType="submit"
          label="Proceed"
        // loading={loading}
        />
        
      </div>
    </div>
  );
}

export default InstagramGenericMessage;
